<template>
  <button
    class="toggle-button"
    :disabled="disabled"
    :class="{
      'active': modelValue,
      [type]: type,
      'toggle-button-hover': hoverStyle && showHover,
      'toggle-button-active': showActive,
      'toggle-button-disabled': disabled
    }"
    @click.stop="handleButtonClick"
    @mousedown.prevent=""
  >
    <div class="button-content">
      <SVGIcon
        :width="iconSize"
        :height="iconSize"
        :iconName="currIcon"
        :iconColor="iconColor"
        class="button-icon"
      />
      <span>
        <slot />
      </span>
    </div>
  </button>
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';

export default {
  name: 'IconButton',
  components: {
    SVGIcon,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    iconActive: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    iconSize: {
      type: [Number, String],
      default: '20px',
    },
    type: {
      type: String,
      default: 'toggle',
    },
    showHover: {
      type: Boolean,
      default: true,
    },
    showActive: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    hoverStyle() {
      return this.type !== 'tooltip-hover';
    },
    currIcon() {
      return this.modelValue && this.iconActive ? this.iconActive : this.icon;
    },
  },
  methods: {
    handleButtonClick() {
      if (!this.disabled) {
        this.$emit('update:modelValue', !this.modelValue);
        this.$emit('change', !this.modelValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-button {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: 1px solid var(--button-secondary-outlined-border);
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s ease;
  color: var(--body-text-color);
  white-space: nowrap;

  .button-content {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }

  .button-icon {
    display: flex;
    align-items: center;
  }

  &.toggle-button-hover:hover:not(.toggle-button-disabled) {
    background-color: var(--color-primary-100);
  }

  &.active {
    // background-color: var(--button-active);
    background-color: var(--color-primary-100);
    border: 2px solid var(--color-primary);
    color: var(--color-primary);
    font-weight: 500;
  }

  &.toggle-button-disabled {
    color: var(--color-disabled);
    cursor: not-allowed;
    border-color: var(--color-disabled);
  }
}
</style>
